import { render, staticRenderFns } from "./AuthorData.vue?vue&type=template&id=20ac1a76&scoped=true&"
import script from "./AuthorData.vue?vue&type=script&lang=js&"
export * from "./AuthorData.vue?vue&type=script&lang=js&"
import style0 from "./AuthorData.vue?vue&type=style&index=0&id=20ac1a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ac1a76",
  null
  
)

/* custom blocks */
import block0 from "./AuthorData.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports